<template functional>
  <transition name="slideup">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'SlideUpTransition',
};
</script>

<style lang="scss">
.slideup-enter-active,
.slideup-leave-active {
  transition: all 0.3s ease-out;
  transform: translateY(9) scale(0);
}

.slideup-enter,
.slideup-leave-to {
  transform: translateY(100%) scale(0.9);
}
</style>
